(function(){
    'use strict';

    angular.module('app').controller('PendingImportModalController', PendingImportModalController);

    PendingImportModalController.$inject = ['PendingZoneImportTableService', 'CarrierLoadRatesTableService', '$uibModalInstance', 'param', 'Carrier','toastr'];

    function PendingImportModalController(PendingZoneImportTableService, CarrierLoadRatesTableService, $uibModalInstance, param, Carrier, toastr){
        let vm = this;
        vm.initPendingRates = initPendingRates;
        vm.rateTypes = angular.getObjVal(param, 'serviceProfile.service.rateCategories') || [];
        if(param.name === 'zoneImport')
            vm.pendingImportTable = new PendingZoneImportTableService(param.paramId, param.countries).tableData;
        vm.confirmImport = ()=>{
            if(param.name === 'zoneImport'){
                Carrier.confirmImportZonePostcode(param.paramId || param.serviceProfile.id, data=>{
                    $uibModalInstance.close(true);
                    toastr.success('CSV successfully imported!');
                },error=>{
                    toastr.error('Unable to confirm import', error.message);
                });
            }
            else{
                Carrier.confirmRateCards(param.paramId || param.serviceProfile.id, data=>{
                    $uibModalInstance.close(true);
                    toastr.success('CSV successfully imported!');
                },error=>{
                    toastr.error('Unable to confirm import', error.message);
                });
            }
        };
        vm.rejectImport = () =>{
            if(param.name === 'zoneImport'){
                Carrier.rejectImportZonePostcode(param.paramId || param.serviceProfile.id, data=>{
                    $uibModalInstance.close(true);
                    toastr.success('Import rejected');
                },error=>{
                    toastr.error('Unable to reject import', error.message);
                });
            }else{
                Carrier.rejectRateCards(param.paramId || param.serviceProfile.id, data=>{
                    $uibModalInstance.close(true);
                    toastr.success('Import rejected');
                },error=>{
                    toastr.error('Unable to reject import', error.message);
                });
            }
        };
        vm.close =  () =>{
            $uibModalInstance.dismiss();
        }
        function initPendingRates(rateType) {
            vm[rateType.value] = new CarrierLoadRatesTableService(angular.copy(param.serviceProfile), angular.copy({
                rateType, isDraft: true
            })).tableData;
        }
    }

})();


// WEBPACK FOOTER //
// ./js/controllers/carriers/pendingImportModalController.js